import { Component, Element, Host, Prop, State, h } from '@stencil/core';

import dynamicEntryActions from '../../../actions/actions.dynamic-entry';
import { icoTabItem } from '../../../interfaces/interface.tabGroup';
import { IcoDynamicContentLoader } from '../../loaders/IcoDynamicContentLoader';

@Component({
  tag: 'dynamic-form-selector',
  styleUrl: 'dynamic-form-selector.css',
})
export class DynamicFormSelector {
  @Element() el: HTMLElement;
  @Prop() tabs: icoTabItem[] = [];
  @Prop() selectedTab: string = '';
  @Prop() defaultTab: string = '';
  @Prop() changeTab: (key: string) => void = () => {};
  @Prop() showDesktop: boolean = false;
  @Prop() tabAttributes: {} = {};
  @Prop() commonAttributes: {} = {};
  @Prop() containerClass: string = 'mt-2';
  @Prop() componentPrefix: string = '';
  @Prop() componentSuffix: string = '';
  @Prop() isTabRendering: boolean = true;
  @Prop() useSkeletonLoading: boolean = false;

  @State() previouslyLoadedTabs: Set<string> = new Set(['vin']);

  tabClick = (tabKey: string) => {
    if (tabKey !== this.selectedTab) {
      // prevents flashing when switching between previously loaded tabs
      if (!this.previouslyLoadedTabs.has(tabKey)) {
        dynamicEntryActions.onStoreUpdate({ isTabRendering: true });
        this.previouslyLoadedTabs = new Set([...this.previouslyLoadedTabs, tabKey]);
      }

      this.changeTab(tabKey);
    }
  };

  componentDidLoad() {
    setTimeout(() => {
      dynamicEntryActions.onStoreUpdate({ isComponentRendering: false });
    }, 300);
  }

  render() {
    if (this.useSkeletonLoading && this.isTabRendering) {
      this.el.style.setProperty('--skeleton-loading-display', 'block');
      this.el.style.setProperty('--content-loader-display', 'none');
    } else {
      this.el.style.setProperty('--skeleton-loading-display', 'none');
      this.el.style.setProperty('--content-loader-display', 'block');
    }

    const currentTab = this.selectedTab || this.defaultTab;
    const containerStyleClass = `${this.containerClass} [display:var(--content-loader-display)]`;

    return (
      <Host>
        <ico-banner-tab-group selectedKey={currentTab} tabs={this.tabs} actions={{ select: this.tabClick }} showDesktop={this.showDesktop} />
        <dynamic-skeleton-loading class="[display:var(--skeleton-loading-display)]" useMiddleRow={currentTab !== 'plate'}></dynamic-skeleton-loading>
        <IcoDynamicContentLoader
          prefix={this.componentPrefix}
          suffix={this.componentSuffix}
          section={currentTab}
          classes={containerStyleClass}
          {...this.tabAttributes[currentTab]}
          {...this.commonAttributes}
        />
      </Host>
    );
  }
}
